import { render, staticRenderFns } from "./listaTipoClasse.vue?vue&type=template&id=a8b60c94&scoped=true"
import script from "./listaTipoClasse.vue?vue&type=script&lang=js"
export * from "./listaTipoClasse.vue?vue&type=script&lang=js"
import style0 from "./listaTipoClasse.vue?vue&type=style&index=0&id=a8b60c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b60c94",
  null
  
)

export default component.exports